module.exports = __webpack_public_path__ + "static/media/20ECE9.6eb89a7d.jpg";